import React from "react";
import PropTypes from "prop-types";

const ChevronRightSolidIcon = ({
  width,
  height,
  color,
  className,
  ...props
}) => (
  <svg
    width={width || 5}
    height={height || 10}
    viewBox="0 0 5 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path d="M0 0L4.66667 4.66667L0 9.33333" fill={color} />
  </svg>
);

ChevronRightSolidIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  className: PropTypes.string,
};

ChevronRightSolidIcon.defaultProps = {
  width: undefined,
  height: undefined,
  color: "currentColor",
  className: "",
};

export default ChevronRightSolidIcon;
